import React, { useEffect, useState, useRef } from "react";
import { Button, Box, Alert } from "@mui/material";
import { useAuth, useSnackbar, useLoading, useNavigation } from "../../Context/Contexts";
import CenteredCard from "../../components/Card/CenteredCardLayout";
import { useTranslation } from "react-i18next";
import { ToolbarWithSaveHandle } from "../../components/Toolbar/ToolbarWithSave";

const FortnoxSetupPage: React.FC<{ params?: { [key: string]: any } }> = ({ params }) => {
    const { t } = useTranslation();
    const { code = "", state, integrationId, error } = params || {};
    const [isLoading, setIsLoading] = useState(false);
    const { showLoading, hideLoading } = useLoading();
    const { authService } = useAuth();
    const { showSnackbar } = useSnackbar();
    const { goBack, navigate } = useNavigation();

    useEffect(() => {
        isLoading ? showLoading() : hideLoading();
    }, [isLoading, showLoading, hideLoading]);

    const handleSave = async () => { };

    useEffect(() => {
        installFortnox();
    }, [code, state]);

    useEffect(() => {
        if (error) {
            showSnackbar(error, "error");

            const timeout = setTimeout(() => {
                navigate({ path: "/integration/list"});
            }, 2000);

            return () => clearTimeout(timeout); // cleanup if component unmounts

        }
    }, [error]);

    const generateFortnoxInstallLink = async () => {
        setIsLoading(true);
        try {
            let url = `/integrationApi/GenerateFortnoxInitLink`;
            if (integrationId) {
                url += `?integrationId=${integrationId}`;
            }
            const response = await authService.get<{ link: string }>(url);
            setIsLoading(false);
            window.location.href = response.link;
        } catch (error: any) {
            showSnackbar(`${t("dialog.saveErrorGeneric")} : ${error.response?.data ?? error.message}`, "error");
        } finally {
            setIsLoading(false);
        }
    };

    const installFortnox = async () => {
        //we send integrationId as state
        if (!code || !state) return;
        setIsLoading(true);
        try {
            var response = await authService.post<{ integrationId: number }>(`/integrationApi/InstallFortnox`, { code, state });
            await showSnackbar(t("dialog.fortnoxInstallSuccess"), "success");
            setIsLoading(false);
            if (state) navigate({ path: "/integration/edit", params: { id: response.integrationId } });
        } catch (error: any) {
            showSnackbar(`${t("dialog.saveErrorGeneric")} : ${error.response?.data ?? error.message}`, "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <CenteredCard title={t("common.integration")} isLoading={isLoading}>
            <Alert severity="info" sx={{ mb: 2 }}>
                {t("dialog.fortnoxInstallMessage")}
            </Alert>
            <Box sx={{ textAlign: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    onClick={generateFortnoxInstallLink}
                    disabled={isLoading || !!code}
                    sx={{ mr: 2 }}
                >
                    {t("common.install")}
                </Button>
            </Box>
            <Box sx={{ mt: 2, textAlign: "center" }}>
                <Button variant="contained" onClick={handleSave} disabled={isLoading} sx={{ mr: 2 }}>
                    {t("common.save")}
                </Button>
                <Button variant="outlined" onClick={goBack}>
                    {t("common.back")}
                </Button>
            </Box>
        </CenteredCard>
    );
};

export default FortnoxSetupPage;

